<template>
  <fin-tabs :tab-items="tabItems" background-color-tab-items="#FFFFFF"
            :no-item-title-padding="true"
            :no-item-content-padding="true"
            :slider-size="2">
    <template #0>
      <fin-archetype-properties :archetype-classifications="archetypeClassifications"
                                :classificationProps="classificationProps"
                                class="fin-archetype-properties"
                                ref="properties"/>
    </template>
    <template #1>
      <fin-target-matrix :archetype-classifications="archetypeClassifications"
                         :readonly="true"
                         :value="classificationProps"
                         initial-draw
                         class="mb-6"
                         ref="matrix"/>
    </template>
  </fin-tabs>

</template>

<script>
import FinArchetypeProperties from '@/components/pages/onboarding/ArchetypeProperties/index'
import FinTargetMatrix from '@/components/pages/onboarding/ArchetypeTargetMatrix/index'
import FinTabs from "@/components/common/Tabs"

/** Use the `ArchetypePropsMatrixTabs` component for displaying the archetype properties and matrix inside tabs. */
export default {
  name: 'finArchetypePropsMatrixTabs',
  components: {FinTabs, FinTargetMatrix, FinArchetypeProperties},
  props: {
    /** the selected classification properties as object to display */
    classificationProps: {
      type: Object
    },
    /** a list of archetype classifications */
    archetypeClassifications: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabItems: [{name: "Eigenschaften"}, {name: "Zielmatrix"}]
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .archetype-property div:nth-child(1) {
  max-width: 200px;
}

::v-deep .v-window {
  overflow: visible;
}
</style>
